import { setItem } from "../../common/localStorage";
import CloneIcon from "../../assets/cloneIcon.svg";

export const dashboardColumns = (navigate, options = {}) => [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName",
    sorter: {
      compare: (a, b) => a.productName.localeCompare(b.productName),
    },
  },
  {
    title: "Product Code",
    dataIndex: "productCode",
    key: "productCode",
    sorter: {
      compare: (a, b) => a.productCode.localeCompare(b.productCode),
    },
  },
  {
    title: "Product Status",
    dataIndex: "productStatus",
    key: "productStatus",
    sorter: {
      compare: (a, b) => a.productStatus.localeCompare(b.productStatus),
      multiple: 3,
    },
    render: (key) => {
      return (
        <div className={key === "Active" ? "activted" : "inactive"}>{key}</div>
      );
    },
  },
  {
    title: "Action",
    key: "action",
    render: (row) => {
      if (!options.showClone && !options.showView && !options.showManage) {
        return null;
      }

      return (
        <div className="action-icons">
          <div className="grid2 d-flex">
            {options.showClone && (
              <button
                className="manage d-flex align-items-center gap-1 w-auto"
                onClick={() => {
                  if (options.onClone) {
                    options.onClone(row);
                  }
                }}
              >
                <img src={CloneIcon} alt="Clone" />
                Clone
              </button>
            )}
            {options.showManage && (
              <button
                className="manage"
                onClick={() => {
                  navigate("/edit-product", { state: row });
                  setItem("productId", row?.productId);
                }}
              >
                Manage
              </button>
            )}
            {options.showView && (
              <button
                className="manage"
                onClick={() => {
                  navigate("/view-product", { state: row });
                  setItem("productId", row?.productId);
                }}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
